module.exports = __webpack_public_path__ + "img/组 361.e7a082b1.png";